import { useCallback, useState } from 'react';

function useToggleDropdown(initialValue = false): [boolean, (value: boolean) => void] {
    const [value, setValue] = useState(initialValue);
    const setToggleDropdown = useCallback((state: boolean): void => {
        setValue(state);
    }, []);
    return [value, setToggleDropdown];
}

export default useToggleDropdown;
